import Steps, { Step } from 'rc-steps';
import { isNullOrUndefined } from 'util';
import $ from "jquery";
var OrderDeliveryOption = require('../General/DeliveryOption').DeliveryOption;
var OrderPaymentOption = require('../General/PaymentOption').PaymentOption;
import { AbconetApi } from '../General/AbconetApi';
var formatMoney = require('../General/Helper').formatMoney;
import ReactTooltip from 'react-tooltip'
import moment from "moment";
import { getErrorCollection, getStockInfo, getEta } from "./CartFunctions";
var CartCreateButton = require('./CartCreateButton').CartCreateButton;
var CartDetails = require('./CartDetails').CartDetails;


class CheckoutSummary extends React.Component {

    renderItem(line, hidePrices) {

        var stockInfo = getStockInfo(this.props.cart, line.product, line.quantity, line.stockLevel);
        var stockAvailabilityElement = null;
        if (stockInfo && stockInfo.willTriggerBackorder) {
            stockAvailabilityElement = <div style={{ "fontSize": "12px", "color": "#ff8100", "backgroundColor": "#ffffff", "borderColor": "#ffffff" }} className="description warning-block" data-tip='This product will cause a backorder.'>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                </svg>
                <strong> BACK ORDER </strong>
            </div>;
        }

        if (stockInfo && stockInfo.issue != null) {
            stockAvailabilityElement = <div style={{ "fontSize": "12px", "color": "#ff8100", "backgroundColor": "#ffffff", "borderColor": "#ffffff" }} className="description error-block" data-tip={stockInfo.issue}>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                </svg>
                <strong> BACK ORDER </strong>
            </div>;
        }

        var rechargeable;
        if (line.rechargeable) {
            rechargeable = <span className="rechargeable-item"> <i className="icon icon-rechargeable" data-tip="Rechargeable item"></i> <ReactTooltip /></span>;
        }

        var lineTotal = formatMoney(line.lineTotal);
        if (hidePrices) {
            lineTotal = "";
        }

        if (line.quantity > 0) {
            return <React.Fragment>
                <div key={line.stockcode} className="row line-row">
                    <div className="col-8">
                        <div className="description">{line.description}</div>
                        <div><small>Quantity: {line.quantity}</small>{rechargeable}</div>
                    </div>
                    <div className="col-4 line-total">
                        {lineTotal}
                    </div>
                    {stockAvailabilityElement}
                </div>
            </React.Fragment>
        }
    }

    renderSubTotalAmount(line, multipleDeliveries) {

        var stockInfo = getStockInfo(this.props.cart, line.product, line.quantity, line.stockLevel);

        var amount = 0;

        if (stockInfo && stockInfo.willTriggerBackorder && multipleDeliveries) {
            amount = line.lineTotal;
        } else if (stockInfo && !stockInfo.willTriggerBackorder && !multipleDeliveries) {
            amount = line.lineTotal;
        }

        return { amount };
    }


    renderItemSubTotal(value) {
        return <div className="row">
            <div className="col-7">
                Sub total
            </div>
            <div className="col-5 px-4 text-right">
                {formatMoney(value)}
            </div>
        </div>
    }


    renderSubTotal() {
        return <div className="row">
            <div className="col-7">
                Sub total
            </div>
            <div className="col-5 px-4 text-right">
                {formatMoney(this.props.cart.subTotal)}
            </div>
        </div>
    }

    renderFreightCost() {

        var freightCost = this.props.cart.freightCost;

        var additionalFreightCharge;

        if (this.props.cart.multipleDeliveries && this.props.cart.additionalFreightCharge > 0) {
            additionalFreightCharge = <span>
                <i style={{ "marginLeft": "-104px", "color": "#00a2a5" }} className="icon icon-info" data-tip={formatMoney(this.props.cart.additionalFreightCharge) + " added for backorder delivery fee"} ></i><ReactTooltip />
            </span>;
        }


        if (!isNullOrUndefined(this.props.cart.freightCost)) {
            return <div className="row">
                <div className="col-7">
                    <a href="/shipping" target="_blank">Delivery
                    </a>
                </div>
                <div className="col-5 px-4 text-right">
                    {additionalFreightCharge}
                    {formatMoney(freightCost)}
                </div>


                <div className="col-7"> </div>
                <div className="col-5 px-4 text-right">
                    <hr />
                </div>

            </div>;
        }
    }

    renderSurchargeCost() {
        if (this.props.cart.surchargeCost === 0) {
            return null;
        }

        return <div className="row">
            <div className="col-7">
                <a href="/fuel-surcharge/">Fuel Levy</a> <i className="icon icon-info" data-tip='Temporary levy for high fuel prices, click to learn more'></i>   <ReactTooltip />
            </div>
            <div className="col-5 px-4 text-right">
                {formatMoney(this.props.cart.surchargeCost)}
            </div>
        </div>;
    }

    renderCreditCardSurchargeCost() {
        if (this.props.cart.creditCardSurchargeCost === 0) {
            return null;
        }

        return <div className="row">
            <div className="col-7" style={{ "letter-spacing": "-0.5px" }}>
                Credit Card Surcharge <i className="icon icon-info" data-tip='1.75% surcharge for credit card payment'></i> <ReactTooltip />
            </div>
            <div className="col-5 px-4 text-right">
                {formatMoney(this.props.cart.creditCardSurchargeCost)}
            </div>
        </div>;
    }

    renderSingleDelivery() {
        var showBackorder = true;
        var subTotal = 0;

        if (this.props.cart.multipleDeliveries) {
            showBackorder = false;
        }

        return <div>
            <div className="checkout-summary">
                <h4>Order Summary</h4><ReactTooltip />
                <div className="line-summary">
                    {this.props.cart.lines.map(x => this.renderItem(x, this.props.hidePrices, showBackorder, false))}
                </div>

                {!showBackorder &&
                    <div>
                        {this.props.cart.lines.map((x) => {
                            var result = this.renderSubTotalAmount(x, false)
                            subTotal += result.amount;
                        })}
                        {this.renderItemSubTotal(subTotal)}
                        {this.renderFreightCost(true)}
                    </div>
                }
            </div>
        </div>
    }

    renderMultipleDeliveries() {

        var subTotal = 0;

        if (this.props.cart.multipleDeliveries) {
            return <div>
                <div className="checkout-summary">
                    <h4>Order Summary</h4><ReactTooltip />
                    <div className="line-summary">
                        {this.props.cart.lines.map(x => this.renderItem(x, this.props.hidePrices, true, true))}
                    </div>
                    <div>
                        {this.props.cart.lines.map((x) => {
                            var result = this.renderSubTotalAmount(x, true)
                            subTotal += result.amount;
                        })}
                        {this.renderItemSubTotal(subTotal)}
                        {this.renderFreightCost(true)}
                    </div>
                </div> <br />
            </div>
        }
    }

    render() {
        if (this.props.cart == null) {
            return <div>No active cart.</div>;
        }

        var totalPanel = <div >
            {this.renderSubTotal()}
            {this.renderFreightCost()}
            {this.renderCreditCardSurchargeCost()}
            <div className="row">
                <div className="col-7">
                    GST
                </div>
                <div className="col-5 px-4 text-right">
                    {formatMoney(this.props.cart.totalTax)}
                </div>
            </div>
            <div className="row">
                <div className="col-7">
                    Total EX. GST</div>
                <div className="col-5 px-4 text-right">
                    {formatMoney(this.props.cart.totalPrice)}
                </div>
            </div>




            <div className="row cart-total">
                <div className="col-7">
                    Total INC. GST
                </div>
                <div className="col-5 px-4 text-right">
                    {formatMoney(this.props.cart.totalPrice + this.props.cart.totalTax)}
                </div>
            </div>
        </div>;

        if (this.props.hidePrices) {
            totalPanel = "";
        }

        return <React.Fragment>
            <h3 style={{ "visibility": "hidden" }}> Order Summary </h3>
            <div className="checkout-summary">
                <h4>Order Summary</h4><ReactTooltip />
                <div className="line-summary">
                    {this.props.cart.lines.map(x => this.renderItem(x, this.props.hidePrices))}
                </div>

                {totalPanel}
            </div>

        </React.Fragment>
    }
}

class PunchoutCheckout extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hasSubmitted: false
        }
    }

    deleteCart(cartId) {

        AbconetApi.post('/api/cart/sentToCoupa', this.props.punchout.data);


        AbconetApi
            .delete('/api/cart/' + cartId + '/delete')
            .then(() => {
                $(document).trigger("CartUpdated");
            });

        this.setState({ hasSubmitted: true });

        AbconetApi.post('/api/auth/logout', null);


    }

    renderCartSummary() {

        if (this.props.renderStep0 && this.props.skipReplacement == false) {
            return null;
        }

        return <div className="col-12 col-lg-6">
            <CheckoutSummary cart={this.props.cart} hidePrices={this.props.hidePrices} />
        </div>
    }

    renderPunchoutStep() {

        if (this.props.renderStep0 && this.props.skipReplacement == false) {
            return this.props.renderStep0();
        }

        var hasSubmitted = this.state.hasSubmitted;

        return <div className="col-12 col-lg-6 order-lg-2 mb-4">
            <div>
                <h3 className="mt-3">Checkout</h3>
                Your order will be sent to your supplier portal.

                <form id="PunchoutReturnForm" method="POST" action={this.props.punchout.url}>
                    <input type="hidden" name="cXML-urlencoded" value={this.props.punchout.data} />
                    <input type="submit" className="btn btn-primary mt-2" value="Checkout" onClick={() => this.deleteCart(this.props.cart.id)} />
                </form>

                {hasSubmitted && <div style={{
                    "position": "fixed",
                    "top": "0",
                    "left": "0",
                    "right": "0",
                    "bottom": "0",
                    "background": "white",
                    "zIndex": "999999"
                }}>
                    <h3>Your cart has been submitted and your sessions has completed.</h3>
                </div>}
            </div>
        </div>;
    }

    render() {

        if (this.props.hasError) {
            return <div className="row cart-checkout">
                <div className="col-12">
                    {this.props.hasError}
                </div>
            </div>
        }


        if (this.props.deliveryType != "PICK-UP" && this.props.cart.address == null) {
            return <div className="row cart-checkout alert alert-danger">
                Please select an address.
            </div>
        }

        var step = 0;
        if (this.props.skipReplacement) {
            step = 1;
        }


        return <div className="row cart-checkout">
            <div className="col-12">
                <Steps progressDot size="small" current={step} labelPlacement="vertical">
                    {this.props.itemReplacement}
                    <Step title="Submit" />
                    <Step title="Review" />
                    <Step title="Complete" />
                </Steps>
            </div>

            {this.renderPunchoutStep()}
            {this.renderCartSummary()}
        </div>;
    }
}

export class CartCheckout extends React.Component {

    constructor(props) {
        super(props);

        var step = 0;

        if (props.initialCart.canEdit == false) {
            step = 2;
        }

        if (props.initialCart.canApprove) {
            step = 1;
        }

        var deliveryType = null;
        if (props.initialCart.pickupLocation != null && props.initialCart.pickupLocation.id != 0) {
            deliveryType = "PICK-UP";
        }

        this.state = {
            cartDetails: {
                cart: props.initialCart
            },
            cart: this.props.initialCart,
            step: step,
            isSaved: false,
            isSaving: false,
            isSubmitted: false,
            isSubmitting: false,
            showSalesNotes: false,
            additionalInformation: this.props.additionalInformation,
            purchaseOrderNumber: this.props.purchaseOrderNumber,
            deliveryInstructions: this.props.deliveryInstructions,
            showForApproverNotes: false,
            noteForApprover: this.props.noteForApprover,
            showCreateNew: this.props.showCreateNew,
            ccv: "",
            multipleDeliveries: this.props.multipleDeliveries,
            deliveryType: deliveryType,
            hasItemReplacement: false,
            dontReplaceCollection: [{
                stockCode: null
            }],
            orderType: null,
            skipReplacement: false
        }

    }

    renderShowMultipleDeliveries(line) {

        if (line.quantity <= 0) {
            return null;
        }

        var stockInfo = getStockInfo(this.state.cart, line.product, line.quantity, line.stockLevel);

        var item = null;


        if (stockInfo && stockInfo.willTriggerBackorder) {
            item = "OutOfStock"
        } else if (stockInfo && !stockInfo.willTriggerBackorder) {
            item = "InStock";
        }


        return { item };
    }

    setShowMultipleDeliveries() {


        var outOfStockCount = 0;

        {
            this.state.cart.lines.map((x) => {
                var result = this.renderShowMultipleDeliveries(x, true)

                if (result != null && result.item != null && result.item == "OutOfStock") {
                    outOfStockCount += 1;
                }
            });
        }

        if (outOfStockCount > 0) {
            return true;
        }


        if (this.state.cart.multipleDeliveries) {
            this.updateMultipleDeliveries(false);
        }

        return false;
    }

    updateDeliveryInstruction(ev) {
        var cart = this.state.cartDetails.cart;
        cart.deliveryInstructions = ev;
        this.setState({ cart: cart });
    }

    updateContactName(ev) {
        var cart = this.state.cartDetails.cart;
        cart.contactName = ev;
        this.setState({ cart: cart });
    }

    updateContactNumber(ev) {
        var cart = this.state.cartDetails.cart;
        cart.contactNumber = ev;
        this.setState({ cart: cart });
    }

    updatePurchaseOrderNumber(ev) {
        var cart = this.state.cartDetails.cart;
        cart.purchaseOrderNumber = ev.target.value;
        this.setState({ cart: cart });
    }

    updateMultipleDeliveries(ev) {
        var cart = this.state.cart;
        cart.multipleDeliveries = ev;

        var self = this;
        AbconetApi.post(`/api/cart/`, cart).then(cart => {
            self.setState({
                cart: cart
            });
            $(document).trigger("CartUpdated", cart);
        });
    }

    updateShippingType(ev) {
        return new Promise((resolve, reject) => {
            var cart = this.state.cart;
            cart.shippingType = ev;

            AbconetApi.post(`/api/cart/`, cart)
                .then(updatedCart => {
                    this.setState({
                        cart: updatedCart
                    });

                    $(document).trigger("CartUpdated", updatedCart);
                    resolve(updatedCart);
                })
                .catch(error => {
                    cart.shippingType = "NORMAL";
                    console.error('Error updating shipping type:', error);
                    reject(error);
                });
        });
    }

    setStep(stepNumber) {
        this.setState({ step: stepNumber });
    }

    setDeliveryType(value) {
        this.setState({
            deliveryType: value
        });
    }

    setDeliveryOption(deliveryOption) {
        var currentCart = this.state.cart;

        currentCart.pickupLocation = deliveryOption.pickupLocation;
        currentCart.address = deliveryOption.address;

        currentCart.secureLocation = deliveryOption.secureLocation;
        currentCart.ownCourier = deliveryOption.ownCourier;

        var self = this;
        AbconetApi.post(`/api/cart/`, currentCart).then(cart => {
            self.setState({
                cart: cart
            });
            $(document).trigger("CartUpdated", cart);
            window.location = '/cart/checkout/';
        });
    }

    setPaymentOption(paymentOption) {

        var currentCart = this.state.cart;
        currentCart.paymentOption = paymentOption.paymentType;

        if (paymentOption.paymentType === "CREDITCARD") {
            currentCart.paymentToken = paymentOption.creditCard;
        }

        AbconetApi.post(`/api/cart/`, currentCart).then(cart => {
            this.setState({
                cart: cart
            });
            $(document).trigger("CartUpdated", cart);
        });

    }

    pushTracking(orderNumber) {
        var cartItems = this.state.cart.lines.map((item) => {
            return {
                'item_name': item.description,      
                'item_id': item.stockcode,
                'quantity': item.quantity,
                'price': item.unitPrice
            }
        });
        function generateUniqueTransactionId() {
            const timestamp = Date.now();
            const randomPart = Math.floor(Math.random() * 10000); // Generate a random number between 0 and 999999
            const transactionId = `T_${timestamp}_${randomPart}`;
            return transactionId;
        }
        dataLayer.push({ ecommerce: null }); 
        dataLayer.push({
            event: "purchase",
            ecommerce: {
                transaction_id: generateUniqueTransactionId(),
                value: this.state.cart.totalPrice,
                currency: "AUD",
                items: cartItems,
            }
        })
    }

    approveOrder() {
        this.setState({ isSubmitting: true });

        var self = this;
        var cart = { id: -1 };
        var step = 2;

        if (this.state.hasItemReplacement) {
            step = 3;
        }

        AbconetApi.post(`/api/cart/${this.state.cart.id}/approve`).then(response => {

            self.setState({ isSubmitting: false, isSubmitted: true });



            if (response.type === "Glad") {
                self.setState({
                    cart: response.cart,
                    step: step,
                    responseType: "Glad"
                });
            } else if (response.type === "Approval") {
                self.setState({
                    cart: response.cart,
                    step: step,
                    group: response.group
                });
            } else {
                if (response.cart) {
                    this.pushTracking(response.cart.id);
                }
                
                self.setState({
                    orderNumber: response.id,
                    step: step
                });
            }

            $(document).trigger("CartUpdated", cart);
            $("html, body").animate({ scrollTop: 0 }, 250);
        });
    }

    handleCcvChange(event) {
        this.setState({ ccv: event.target.value });
    }

    saveContactDetailsToSite() {
        var address = this.props.initialCart.address;
        var cart = this.state.cartDetails.cart;
        if (address.note != cart.deliveryInstructions || address.siteContactName != cart.contactName || address.siteContactPhone != cart.contactNumber) {

            address.note = cart.deliveryInstructions;
            address.siteContactName = cart.contactName;
            address.siteContactPhone = cart.contactNumber;

            AbconetApi.post(`/api/address/`, address).then(address => {

            });
        }
    }

    submitOrder() {
        if (this.state.cart.paymentOption === "CREDITCARD" && this.state.ccv.length != 3) {
            alert("Please enter the CCV");
            return;
        }


        this.setState({ isSubmitting: true });

        var self = this;
        var cart = { id: -1 };

        var step = 2;
        if (this.state.hasItemReplacement) {
            step = 3;
        }

        if (this.state.deliveryType != "PICK-UP") {
            this.saveContactDetailsToSite();
        }
        AbconetApi.post(`/api/cart/${this.state.cart.id}/checkout`,
            {
                ccv: this.state.ccv
            }).then(response => {


                self.setState({ isSubmitting: false, isSubmitted: true });

                if (response.type === "Glad") {
                    self.setState({
                        cart: response.cart,
                        step: step,
                        responseType: "Glad"
                    });
                } else if (response.type === "Approval") {
                    self.setState({
                        cart: response.cart,
                        step: step,
                        group: response.group
                    });
                } else {

                    this.pushTracking(response.id);

                    self.setState({
                        orderNumber: response.id,
                        step: step
                    });
                }

                $(document).trigger("CartUpdated", cart);
                $("html, body").animate({ scrollTop: 0 }, 250);
            }).catch(() => {
                this.setState({ isSubmitting: false });
            });
    }

    sendOrderForReview() {
        if (this.state.deliveryType == "PICK-UP" && this.state.cart.pickupLocation == null) {
            alert('No warehouse selected');
            return;
        }

        if (this.props.siteRequiredForAllOrders && this.state.cart.address == null) {
            alert('Please select an address.');
            return;
        }

        if (this.state.deliveryType != "PICK-UP" && this.state.cart.address == null) {
            alert('No address selected');
            return;
        }

        if (this.state.cart.paymentOption == "CREDITCARD" && this.state.cart.paymentToken == null) {
            alert('Please enter payment details');
            return;
        }

        if (this.state.cart.requiresOrderNumber == true && (isNullOrUndefined(this.state.cart.purchaseOrderNumber) || this.state.cart.purchaseOrderNumber == '')) {
            alert('Please enter purchase order number');
            return;
        }

        if (this.state.deliveryType != "PICK-UP" && (this.state.cartDetails.cart.contactName == null || this.state.cartDetails.cart.contactName.trim() == "")) {
            alert('Please enter contact name')
            return;
        }

        if (this.state.deliveryType != "PICK-UP" && (this.state.cartDetails.cart.contactNumber == null || this.state.cartDetails.cart.contactNumber.trim() == "")) {
            alert('Please enter contact number')
            return;
        }

        if (this.state.cart.requiresOrderNumber && !isNullOrUndefined(this.state.cart.orderNumberFormat)) {
            var regex = new RegExp(this.state.cart.orderNumberFormat);
            if (!regex.test(this.state.cart.purchaseOrderNumber)) {
                alert('Purchase order number format is invalid');
                return;
            }
        }

        this.setState({ isSaving: true });

        var step = 1;
        if (this.state.hasItemReplacement) {
            step = 2;
        }

        var self = this;
        AbconetApi.post(`/api/cart/`, this.state.cart).then(cart => {
            setTimeout(
                () => {
                    self.setState({ isSaving: false, isSaved: true });

                    cart.contactName = this.state.cartDetails.cart.contactName;
                    cart.contactNumber = this.state.cartDetails.cart.contactNumber;

                    setTimeout(() => {
                        self.setState({
                            cart: cart,
                            step: step
                        });
                        $("html, body").animate({ scrollTop: 0 }, 250);
                    },
                        500);
                },
                200);
        });

    }

    validateDiscontinuedItem() {
        var line = this.state.cart.lines;

        for (var i = 0; i < line.length; i++) {
            var hasDontReplaceStockCode = this.state.dontReplaceCollection.filter(x => x.stockCode == line[i].stockcode);
            if (hasDontReplaceStockCode.length === 0) {
                var stockInfo = getStockInfo(this.state.cart, line[i].product, line[i].quantity, line[i].stockLevel);
                if (stockInfo && stockInfo.willTriggerBackorder && (stockInfo.isDiscontinued)) {
                    if (line[i].product.alternativeProductCollection.length > 0) {
                        return line[i].stockcode + " - " + line[i].product.name + " is discontinued. You cannot order discontinued items.";
                    }

                }
            }
        }

        return null;
    }

    goDeliveryStep() {

        var step = 0;

        if (this.state.hasItemReplacement) {
            var discontinuedItemCollection = this.validateDiscontinuedItem()
            if (discontinuedItemCollection != null) {
                return alert(discontinuedItemCollection);
            }

            step = 1;
        }

        this.setState({
            step: step,
            isSaved: false,
            isSaving: false,
            skipReplacement: true
        });

        window.scrollTo(0, 0)
    }

    goItemReplacementStep() {
        this.setState({
            step: 0,
            isSaved: false,
            isSaving: false,
        });
    }

    showSalesNotes() {

        var showForApproverNotes = false;
        var showSalesNotes = false;
        if (this.state.showSalesNotes) {
            showSalesNotes = false;
        }
        else {
            showSalesNotes = true

            if (this.state.showForApproverNotes) {
                showForApproverNotes = false;
            }

        }
        this.setState({
            showForApproverNotes: showForApproverNotes,
            showSalesNotes: showSalesNotes
        });
    }

    showApproverNotes() {

        var showSalesNotes = false;
        var showForApproverNotes = false;
        if (this.state.showForApproverNotes) {
            showForApproverNotes = false;
        }
        else {
            showForApproverNotes = true

            if (this.state.showSalesNotes) {
                showSalesNotes = false;
            }
        }
        this.setState({
            showForApproverNotes: showForApproverNotes,
            showSalesNotes: showSalesNotes
        });
    }

    renderApprovalMessage() {
        if (this.state.cart.requiresApproval && !this.state.cart.canApprove) {

            var message = "Your cart requires approval.";
            switch (this.state.cart.requiresApprovalReason) {
                case 'ALL_ORDERS':
                    return null;
                    break;

                case 'NON_ASL_ITEM':
                    message = "This order has non approved items and requires approval.";
                    break;

                case 'OVER_BUDGET':
                    message = "This order is over budget and requires approval.";
                    break;

                case 'SITE_AUTH':
                    message = "This order is over the authorised spend limit and requires approval.";
                    break;

                case 'ORDER_SPEND':
                    message = "This order is over the order budget and requires approval.";
                    break;

                case 'URGENT_FASTEST':
                    message = "This order is on urgent/fastest shipping and requires approval.";
                    break;
            }

            return <div className="alert alert-warning" role="alert">
                {message}
            </div>;
        }

        return null;
    }

    showStep() {
        if (!this.state.cart.canEdit && this.state.cart.requiresApproval && !this.state.cart.canApprove) {
            return this.renderAwaitingApproval();
        }

        if (isNullOrUndefined(this.state.cart.freightCost)) {
            return this.renderFreightCostError();
        }

        if (this.state.hasItemReplacement) {

            switch (this.state.step) {
                case 0:
                    return this.renderStep0();

                case 1:
                    return this.renderStep1();

                case 2:
                    return this.renderStep2();

                case 3:
                    return this.renderStep3();
            }
        }

        switch (this.state.step) {
            case 0:
                return this.renderStep1();

            case 1:
                return this.renderStep2();

            case 2:
                return this.renderStep3();
        }

        return <div>Incorrect step</div>;
    }

    renderFreightCostError() {
        return <div>
            <h3> Cannot calculate freight cost </h3>
            <p> Sorry, There was an error when calculating the freight cost. <br />
                Please contact our customer success team on 1800 177 399.
            </p>
        </div>;
    }

    renderApprovalInformation() {
        if (this.state.cart.orderApproval != undefined) {
            var canBeApprovedByCollection = [];

            this.state.cart.orderApproval.forEach(function (approval) {
                if (!isNullOrUndefined(approval.canBeApprovedByCollection)) {
                    approval.canBeApprovedByCollection.forEach(function (contact) {
                        var index = -1;
                        index = canBeApprovedByCollection.findIndex(function (obj) {
                            return obj.id === contact.id;
                        });

                        if (index == -1) {
                            canBeApprovedByCollection.push(contact);
                        }

                    });
                }
            });

            return <ul>
                {canBeApprovedByCollection.map((contact) => { return <li>{contact.displayName}</li>; })}
            </ul>;
        }
    }

    renderAwaitingApproval() {
        return <div>
            <h2>Your order is awaiting approval.</h2>
            <p>Order is awaiting approval and can be approved by:</p>
            {this.renderApprovalInformation()}
        </div>
    }

    renderLinkedSite() {
        if (this.state.cart.pickupLocation != null && this.state.cart.address != null) {
            var address = this.state.cart.address;
            return <div>
                <h3>Site</h3>
                <div>{address.addressLine1}</div>
                <div>{address.addressLine2}</div>
                <div>{address.suburb} {address.state} {address.postcode}</div>
                <div>{address.addressLine3}</div>
                <div>{address.addressLine4}</div>
                <div>{address.addressLine5}</div>
                <br />
            </div>;
        }

    }

    renderReviewOrderButton() {
        if (this.props.disableOnlineOrdering) {
            return null;
        }

        if (isNullOrUndefined(this.state.cart.freightCost)) {
            return;
        }

        var errorCollection = getErrorCollection(this.state.cart);

        if (errorCollection.length > 0) {
            return null;
        }

        var btnText = 'Review Order';
        var btnClass = 'changes';

        if (this.state.isSaved) {
            btnText = 'Review Order';
            btnClass = 'saved';
        }

        if (this.state.isSaving) {
            btnText = 'Processing';
            btnClass = 'saving';
        }

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving} onClick={this.sendOrderForReview.bind(this)}>{btnText}</button>;
    }

    renderSubmitButton() {
        if (this.props.ociHookUrl != null && this.props.ociHookUrl != '') {
            return (
                <form action={this.props.ociHookUrl} method="post" target="_top" style={{ display: 'inline', float: 'right' }}>
                    <input type="hidden" name="~OkCode" value="ADDI" />
                    <input type="hidden" name="~target" value="_top" />
                    <input type="hidden" name="~CALLER" value="CTLG" />

                    {this.state.cart.lines.map((item, index) => {
                        return <React.Fragment>
                            <input type="hidden" name={`NEW_ITEM-DESCRIPTION[${index}]`} value={item.description.substring(0, 39)} />
                            <input type="hidden" name={`NEW_ITEM-QUANTITY[${index}]`} value={item.quantity} />
                            <input type="hidden" name={`NEW_ITEM-UNIT[${index}]`} value="EA" />
                            <input type="hidden" name={`NEW_ITEM-PRICE[${index}]`} value={item.lineTotal} />
                            <input type="hidden" name={`NEW_ITEM-PRICEUNIT[${index}]`} value={item.product.bestPrice} />
                            <input type="hidden" name={`NEW_ITEM-CURRENCY[${index}]`} value="AUD" />
                            <input type="hidden" name={`NEW_ITEM-MATNR[${index}]`} value="" />
                            <input type="hidden" name={`NEW_ITEM-MATGROUP[${index}]`} value="" />
                            <input type="hidden" name={`NEW_ITEM-MANUFACTMAT[${index}]`} value={item.product.stockcode} />
                        </React.Fragment>;
                    })}
                    <button className={"btn btn-primary float-right"}>Punchout</button>
                </form>
            );
        }
        else {
            var btnText = 'Submit';
            var btnTextApprove = 'Approve & Submit';
            var btnClass = 'changes';
            if (this.state.isSubmitted) {
                btnText = 'Submitted';
                btnClass = 'saved';
                btnTextApprove = 'Approve';
            }
            if (this.state.isSubmitting) {
                btnText = 'Submitting';
                btnClass = 'saving';
                btnTextApprove = 'Submitting';
            }

            if (this.state.cart.canApprove) {
                return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSubmitted || this.state.isSubmitting} onClick={this.approveOrder.bind(this)}>{btnTextApprove}</button>;
            } else if (this.state.cart.canEdit) {
                return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSubmitted || this.state.isSubmitting} onClick={this.submitOrder.bind(this)}>{btnText}</button>;
            }
        }
    }

    renderStep3() {

        if (this.state.responseType == "Glad") {
            return <div>
                <h2>Purchase Request Sent - Thank you!</h2>
                <h4>Your reference number is {this.state.cart.id}. Please check your portal. </h4>
                <br />
                <br />
                <CartCreateButton PunchoutData={this.props.punchoutData} />

            </div>;
        }

        if (this.state.orderNumber > 0) {
            return <div>
                <h2>Order Complete - Thank you!</h2>
                <h4>Your order number is {this.state.orderNumber}. You will receive an email confirmation shortly. </h4>

                <a href={`/orders/${this.state.orderNumber}`} className="btn btn-primary">View order</a>
                <br />
                <br />
                <CartCreateButton PunchoutData={this.props.punchoutData} />

            </div>;

        }

        return <div>
            <h2>Order Received - Thank you!</h2>
            <h4>Your reference number is CRT{this.state.cart.id
            }. You will receive an email when the order is processed.</h4>

            <br />
            <br />
            <CartCreateButton PunchoutData={this.props.punchoutData} />
        </div>;

    }

    renderBackorderMessage() {
        var notInStockItemCollection = this.state.cart.lines.filter(item => {
            var currentLocation = item.product.stockAvailability.filter((location) => {
                return this.state.cart.supplyLocation == location.locationName;
            });

            if (isNullOrUndefined(currentLocation[0]) || isNullOrUndefined(currentLocation[0].status)) {
                return false;
            }

            if (currentLocation[0].status == "OutOfStock" || currentLocation[0].status == "SpecialOrderOnly") {
                return true;
            }

            return false;
        });

        if (notInStockItemCollection.length == 0) {
            return null;
        }


        var backOrderMessage = "Your order contains items that are on backorder. They will be sent once all backordered items are available.";
        if (this.state.cart.multipleDeliveries) {
            backOrderMessage = "Backordered items will be sent together once they are all available.";
        }


        return <div className="alert alert-warning backorder-warning">
            <div className="card-body">
                <p className="card-text">{backOrderMessage}</p>

                {notInStockItemCollection.map(item => {
                    var currentLocation = item.product.stockAvailability.filter((location) => {
                        return this.state.cart.supplyLocation == location.locationName;
                    });
                    var dateString = moment(currentLocation[0].eta).format("DD MMM");

                    var dateToday = new Date();

                    if (dateString == "Invalid date") {
                        dateString = "To Be Confirmed";
                    } else if (moment(currentLocation[0].eta).format("YYYY/MM/DD") < moment(dateToday).format("YYYY/MM/DD")) {
                        dateString = "To Be Confirmed";
                    }

                    return <div className="row">
                        <div className="col-12"><small>{item.description} - <strong>ETA: {dateString}</strong></small></div>
                    </div>;

                })}

            </div>
        </div>;
    }


    renderCreditAlert() {
        var alert = null;

        if (this.state.cart.creditStatus == "WILL_BE_OVER") {
            alert = <div className="alert alert-danger">This order will put you over your credit terms. This may affect delivery of this order.</div>;
        }

        if (this.state.cart.creditStatus == "WILL_BE_OVER") {
            alert = <div className="alert alert-danger">The account is over the credit terms. This may affect delivery of this order.</div>;
        }

        return <div>
            <p>Charged to account</p>
            {alert}
        </div>;
    }

    renderCartError() {
        if (this.props.disableOnlineOrdering) {
            return <div className="alert alert-danger">Ordering is not allowed. Please contact your Administrator.</div>;
        }

        var errorCollection = getErrorCollection(this.state.cart);

        if (errorCollection.length == 0) {
            return null;
        }

        return errorCollection.map(er => {
            return <div className="alert alert-danger">{er.stockInfo.issue}.</div>;
        });

    }



    renderStep2() {
        let address = this.state.cart.address;
        let title = "Order will be delivered to";

        if (this.state.cart.pickupLocation != null) {
            address = this.state.cart.pickupLocation;
            title = "Order can be picked up from";
        }

        let paymentType = this.renderCreditAlert();
        if (this.state.cart.paymentOption === "CREDITCARD") {
            paymentType = <div>
                Credit card ending {this.state.cart.paymentToken.last4}
                <div>CCV:<input type="text" value={this.state.ccv} onChange={this.handleCcvChange.bind(this)} className="ccvbox" /></div>
            </div>;
        }

        let carrier = null;
        if (this.state.cart.ownCourier !== null) {
            carrier = <div>
                <h3>Order will use a courier</h3>
                <div> {this.state.cart.ownCourier.freightCompanyName} </div>
                <div> {this.state.cart.ownCourier.freightAccountNumber} </div>
                <br />
            </div>;
        }

        return <div>
            {this.renderLinkedSite()}
            <h3>{title}</h3>
            <div>
                <div>{address.name}</div>
                <div>{address.addressLine1}</div>
                <div>{address.addressLine2}</div>
                <div>{address.suburb} {address.state} {address.postcode}</div>
                <div>{address.addressLine3}</div>
                <div>{address.addressLine4}</div>
                <div>{address.addressLine5}</div>
                <br />
                <div>{this.props.initialCart.deliveryInstructions} </div>
                <div>{this.props.initialCart.contactName} </div>
                <div>{this.props.initialCart.contactNumber} </div>
                <br />
            </div>

            {carrier}

            <h3>Order will be paid by the following</h3>
            <div>{paymentType}</div>

            <div>
                {this.renderDispatchInformation()}
                {this.renderShippingInformation()}
                {this.renderBackorderMessage()}

                {this.renderSubmitButton()}
                <button className="btn btn-primary" disabled={this.state.isSubmitting || this.state.isSubmitted} onClick={this.goDeliveryStep.bind(this)}> Back </button>
            </div>
        </div>;
    }

    renderDispatchInformation() {

        if (this.state.deliveryType == "PICK-UP") {
            return <div> </div>;
        }

        var eta = getEta(this.state.cart);

        var dispatchMessage = `Single Dispatch ${eta.singleDispatch}`;
        var dispatchExtraMessage = "All goods will be shipped at once";

        if (this.state.cart.multipleDeliveries) {
            dispatchMessage = `Multiple dispatch ${eta.multipleDispatch}`;
            dispatchExtraMessage = "First delivery contains all items that are available and not on backorder";
        }

        var dispatchInformation = <span>{dispatchMessage} <i className="icon icon-info" data-tip={dispatchExtraMessage}></i> <ReactTooltip /></span>;

        if (!this.state.cart.multipleDeliveries && isNullOrUndefined(eta.singleDispatch)) {
            dispatchInformation = <span>{dispatchExtraMessage}</span>;
        } else if (this.state.cart.multipleDeliveries && isNullOrUndefined(eta.multipleDispatch)) {
            dispatchInformation = <span>{dispatchExtraMessage}</span>;
        }

        return <div>
            <h3>Dispatch Information</h3>
            <div>
                {dispatchInformation}
                <br /><br />
            </div>
        </div>
    }

    renderShippingInformation() {
        if (this.state.deliveryType == "PICK-UP") {
            return <div> </div>;
        }

        if (this.state.cart == null) {
            return <div> </div>;
        }

        var shippingInformation = "Normal";
        var shippingLink = <a href="/shipping" target="_blank">Click here for more information</a >;
     
        switch (this.state.cart.shippingType) {
            case "URGENT":
                shippingInformation = <span>Urgent shipping. Normally within 4 business hours. {shippingLink}</span>
                break;

            case "FASTEST":
                shippingInformation = <span>Fastest possible shipping. Normally within 2 business hours. {shippingLink}</span>
                break;

            default:
                shippingInformation = <span>Normal shipping. {shippingLink}</span>
                break;
        }
        

        return <div>
            <h3>Shipping Information</h3>
            <div>
                {shippingInformation}
                <br /><br />
                </div>
        </div>;

    }


    updateAdditionalInformation(ev) {
        var cart = this.state.cart;
        cart.additionalInformation = ev.target.value;
        this.setState({ cart: cart });
    }
    updateNoteForApprover(ev) {
        var cart = this.state.cart;

        cart.noteForApprover = ev.target.value;
        this.setState({ cart: cart });
    }
    renderNotes() {
        var className = "";
        if (this.state.showSalesNotes) {
            className = "show";
        }

        return <div className={"sales-notes " + className}>
            <strong>Notes for Customer Success Team</strong>
            <div><small>Let our customer service team know of any special requirements</small></div>
            <textarea value={this.state.cart.additionalInformation} className="form-control" onChange={this.updateAdditionalInformation.bind(this)} />
        </div>;
    }

    renderApproverNotes() {
        var className = "";
        if (this.state.showForApproverNotes) {
            className = "show";
        }

        return <div className={"sales-notes " + className}>
            <strong>Notes for approver</strong>
            <div><small>Let the approver know of any special requirements</small></div>
            <textarea value={this.state.cart.noteForApprover} className="form-control" onChange={this.updateNoteForApprover.bind(this)} />
        </div>;
    }

    renderStep1() {
        /* if (this.state.cart.totalPrice <= 0) {
             return <div>
                 <h2>No items in your cart.</h2>
             </div>;
         }*/

        var renderApproverButton = null;
        if (this.state.cart.requiresApproval && !this.state.cart.canApprove) {
            renderApproverButton = <button className="btn btn-outline-primary" onClick={this.showApproverNotes.bind(this)}>Add Notes for Approver</button>
        }

        var renderBackButton = null;
        if (this.state.hasItemReplacement) {
            renderBackButton = <button className="btn btn-primary" disabled={this.state.isSaving} onClick={this.goItemReplacementStep.bind(this)}> Back </button>
        }





        return <div>
            <div>
                <h3>How would you like to receive the order?</h3>
                <OrderDeliveryOption
                    cart={this.state.cart}
                    onChange={this.setDeliveryOption.bind(this)}
                    updateDeliveryInstructionsChange={this.updateDeliveryInstruction.bind(this)}
                    updateContactName={this.updateContactName.bind(this)}
                    updateContactNumber={this.updateContactNumber.bind(this)}
                    updatePurchaseOrderNumberOnChange={this.updatePurchaseOrderNumber.bind(this)}
                    showAuthorityToLeave
                    showDeliveryInstructions
                    showPurchaseOrderNumber
                    showCreateNew={this.state.showCreateNew}
                    multipleDeliveries={this.updateMultipleDeliveries.bind(this)}
                    showMultipleDeliveries={this.setShowMultipleDeliveries()}
                    updateDeliveryType={this.setDeliveryType.bind(this)}
                    updateShippingTypeChange={this.updateShippingType.bind(this)}
                    readOnly={this.props.currentUser && this.props.currentUser.isTemplaCustomer && !isNullOrUndefined(this.props.punchoutData)}
                />
            </div>
            <div>
                <h3 className="mt-3">How would you like pay for the order? </h3>
                <OrderPaymentOption cart={this.state.cart} onChange={this.setPaymentOption.bind(this)} />
            </div>
            <br />


            {renderBackButton}
            <div className="cart-checkout-action-btn-container">
                <button className="btn btn-outline-primary" onClick={this.showSalesNotes.bind(this)}>Add Notes for Customer Success Team</button>
                {renderApproverButton}

                {this.renderReviewOrderButton()}
            </div>
            {this.renderNotes()}
            {this.renderApproverNotes()}

        </div>;
    }

    updateCartOfCheckout(cart) {
        var cartDetails = {
            cart: cart
        }

        this.setState({ hasItemReplacement: false, cart: cart, cartDetails: cartDetails })

        window.scrollTo(0, 0)

    }

    updateDontReplaceCollection(item) {
        this.setState({ hasItemReplacement: false, dontReplaceCollection: this.state.dontReplaceCollection.concat(item) });

    }

    renderStep0() {
        window.scrollTo(0, 0)
        return <div>
            <h3>
                Would you like to replace some items to receive them sooner?
            </h3>
            <p>
                The following items in your order were either low in stock or currently out of stock.
                However, we can replace them for a similar item. <br /> <br />
                If you're not ok with the replacement suggestions, that's ok too.
                Your selected items will be placed on backorder.
            </p> <br />

            <CartDetails initialCart={this.state.cartDetails.cart}
                hidePrices={this.props.hidePrices}
                isItemReplacement={true}
                goToDeliveryStep={this.goDeliveryStep.bind(this)}
                updateCartOfCheckout={this.updateCartOfCheckout.bind(this)}
                updateDontReplaceCollection={this.updateDontReplaceCollection.bind(this)}
                dontReplaceCollection={this.state.dontReplaceCollection}
                disableItemReplacement={this.props.disableItemReplacement}
            />

            <div className={"item"}>
                <button className="btn btn-outline-primary" onClick={this.goDeliveryStep.bind(this)}>I don't want replacements</button>
            </div>
        </div>;
    }

    setHasItemReplacement(line) {

        for (var i = 0; i < line.length; i++) {
            var hasDontReplaceStockCode = this.state.dontReplaceCollection.filter(x => x.stockCode == line[i].stockcode);

            if (hasDontReplaceStockCode.length === 0) {
                var stockInfo = getStockInfo(this.state.cart, line[i].product, line[i].quantity, line[i].stockLevel);
                if (stockInfo && stockInfo.willTriggerBackorder) {
                    if (line[i].product.alternativeProductCollection.length > 0) {
                        if (!this.state.hasItemReplacement) {
                            this.setState({ hasItemReplacement: true });
                            break;
                        }
                    }

                }
            }
        }
    }

    render() {

        var itemReplacement = null;
        if (!this.props.disableItemReplacement) {
            this.setHasItemReplacement(this.state.cart.lines)

            if (this.state.hasItemReplacement) {
                itemReplacement = <Step title="Item replacements" />;
            }
        }

        if (!isNullOrUndefined(this.props.punchoutData)) {
            var hasError = this.renderCartError();


            var renderPunchout = true;

            // Austral Account
            if ([44366].includes(this.props.initialCart.accountId) && this.state.cart.requiresApproval) {
                renderPunchout = false;
            }

            if (renderPunchout) {
                return <div className="row cart-checkout">
                    <div className="col-12">
                        <PunchoutCheckout
                            cart={this.state.cart}
                            hidePrices={this.props.hidePrices}
                            punchout={this.props.punchoutData}
                            hasError={hasError}
                            deliveryType={this.state.deliveryType}
                            renderStep0={this.state.hasItemReplacement ? this.renderStep0.bind(this) : null}
                            skipReplacement={this.state.skipReplacement}
                            itemReplacement={itemReplacement}
                        />
                    </div>
                </div>;
            }
        }

        if (isNullOrUndefined(this.props.punchout) && [3607, 18814, 23809, 23264, 23655, 45342].includes(this.props.initialCart.accountId)) {
            return <div className="alert alert-info">
                <h5>You need to login via Coupa to proceed to checkout.</h5>
            </div>;
        }

        var approvalStep = null;
        if (this.state.cart.requiresApproval && !this.state.cart.canApprove) {
            approvalStep = <Step title="Approve Order" />;
        }
        return <div className="row cart-checkout">
            <div className="col-12">
                {this.renderApprovalMessage()}
                {this.renderCartError()}

                <Steps progressDot size="small" current={this.state.step} labelPlacement="vertical">
                    {itemReplacement}
                    <Step title="Delivery & Payment" />
                    <Step title="Review & Submit" />
                    {approvalStep}
                    <Step title="Order Complete" />
                </Steps>
            </div>

            <div className="col-12 col-lg-4 order-lg-2">
                <CheckoutSummary cart={this.state.cart} hidePrices={this.props.hidePrices} />
            </div>
            <div className="col-12 col-lg-8">

                {this.showStep()}

            </div>

        </div>;
    }

}